<template>
  <div class="overview">
    <!-- Mobile Nav Bar -->
    <ul role="menu" class="nav d-lg-none">
      <li class="nav-item dropdown">
        <a role="none"
          class="nav-link dropdown-toggle"
          data-display="static"
          data-toggle="dropdown"
          ref="dropdown"
          href="#"
          aria-haspopup="true"
          aria-expanded="false"
          >{{ this.navTitle }}</a
        >
        <div class="dropdown-menu">
          <a role="menuitem"
            class="dropdown-item"
            href="#"
            @click="selectTab(0, nav(0))"
            @keydown.enter="selectTab(0, nav(0))"
            :class="{ active: activeTab === 0 }"
            >Assessments overview</a
          >
          <a role="menuitem"
            class="dropdown-item"
            href="#"
            @click="selectTab(1, nav(1))"
            @keydown.enter="selectTab(1, nav(1))"
            :class="{ active: activeTab === 1 }"
            >My saved assessments</a
          >
          <a role="menuitem"
            class="dropdown-item"
            href="#"
            @click="selectTab(2, nav(2))"
            @keydown.enter="selectTab(2, nav(2))"
            :class="{ active: activeTab === 2 }"
            >Notifications</a
          >
          <a role="menuitem"
            class="dropdown-item"
            href="#"
            @click="selectTab(3, tabTitle(3))"
            @keydown.enter="selectTab(3, tabTitle(3))"
            :class="{ active: activeTab === 3 }"
            >My account</a
          >
          <div class="group">
            <span class="dropdown-item-text label-mute">Need help?</span>
            <a role="menuitem"
              class="dropdown-item"
              href="#"
              @click="selectTab(i + generalPageTabStart, page.Title)"
              @keydown.enter="selectTab(i + generalPageTabStart, page.Title)"
              v-for="(page, i) in satContent.GeneralContentPages"
              :key="page.Id"
              :class="{ active: activeTab === i + generalPageTabStart }"
              >{{ page.Name }}
            </a>
          </div>
        </div>
      </li>
    </ul>
    <!-- Mobile Nav Bar End-->
    <div class="row" :class="{ 'd-none d-lg-block': activeTab !== 0 }">
      <div class="col-md-12">
        <h1 class="page-title">{{ this.pageTitle }}</h1>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-3  d-none d-lg-block">
        <div role="navigation">
          <ul  class="list-group">
            <li 
              tabindex="0"
              @click="selectTab(0, tabTitle(0))"
              @keydown.enter="selectTab(0, tabTitle(0))"
              class="list-group-item"
              :class="{ active: activeTab === 0 }"
            >
              Assessments overview
            </li>
            <li 
              tabindex="0"
              @click="selectTab(1, tabTitle(1))"
              @keydown.enter="selectTab(1, tabTitle(1))"
              class="list-group-item"
              :class="{ active: activeTab === 1 }"
            >
              My saved assessments
            </li>
            <li 
              tabindex="0"
              @click="selectTab(2, tabTitle(2))"
              @keydown.enter="selectTab(2, tabTitle(2))"
              class="list-group-item notification"
              :class="{ active: activeTab === 2 }"
            >
              Notifications
              <span class="new-badge" v-if="newNotifications > 0"
                >{{ newNotifications }} new <i class="fas fa-circle fa-xs"></i
              ></span>
            </li>
            <li 
              tabindex="0"
              @click="selectTab(3, tabTitle(3))"
              @keydown.enter="selectTab(3, tabTitle(3))"
              class="list-group-item"
              :class="{ active: activeTab === 3 }"
            >
              My account
            </li>
          </ul>
        </div>
        <div class="flex-container column-direction">
          <div class="help">Need help?</div>
          <a
            tabindex="0"
            @click="selectTab(i + generalPageTabStart, page.Title)"
            @keydown.enter="selectTab(i + generalPageTabStart, page.Title)"
            v-for="(page, i) in satContent.GeneralContentPages"
            :key="page.Id"
            class="contact"
            :class="{ active: activeTab === i + generalPageTabStart }"
          >
            {{ page.Name }} <span class="angle-right-green-sm"></span>
          </a>
        </div>
      </div>
      <!-- <div class="col-md-8">Overviewoo</div> -->
      <div class="col-12 col-lg-9">
        <OverviewHome :satContent="satContent" />
        <OverviewSavedAssessments :satContent="satContent" />
        <OverviewNotifications
          :satContent="satContent"
          :notifications="notifications"
        />
        <OverviewMyAccount
          :satContent="satContent"
          @inputChangedInAccount="inputChangedInAccount"
          @changesSavedOrCancelledInAccount="changesSavedOrCancelledInAccount"
        />

        <OverviewGeneralPage
          v-for="page in satContent.GeneralContentPages"
          :key="page.Id"
          :generalContent="page"
        />
      </div>
    </div>
  </div>
</template>

<script>
//import OverviewNavigationPane from '@/components/overview-navigation-pane';
import OverviewHome from "@/components/overview-home";
import OverviewSavedAssessments from "@/components/overview-saved-assessments";
import OverviewNotifications from "@/components/overview-notifications";
import OverviewMyAccount from "@/components/overview-my-account";
import OverviewGeneralPage from "@/components/overview-general-page";
import { mapGetters } from "vuex";
import { privateRouter } from "../router";

export default {
  name: "Overview",

  data() {
    return {
      selectedIndex: 0, // the index of the selected tab,
      tabs: [], // all of the tabs
      generalPageTabStart: 0,
      pageTitle: "",
      navTitle: "",
      activeTab: 0,
      unsavedChanges: false
    };
  },
  components: {
    OverviewHome,
    OverviewSavedAssessments,
    OverviewNotifications,
    OverviewMyAccount,
    OverviewGeneralPage
  },
  async created() {
    this.tabs = this.$children;
  },
  mounted() {
    this.generalPageTabStart =
      this.tabs.length - this.satContent.GeneralContentPages.length; // index of the first general content page tab
    this.selectTab(
      this.activeTabFromQuery,
      this.tabTitle(this.activeTabFromQuery)
    );
  },
  props: {
    satContent: {
      type: Object,
      default: () => {}
    },
    notifications: {
      type: Array,
      default: () => []
    },
    activeTabFromQuery: {
      type: Number,
      default: () => 0
    }
  },
  methods: {
    selectTab(i, page) {
      this.selectedIndex = i;
      // loop over all the tabs
      this.tabs.forEach((tab, index) => {
        tab.isActive = index === i;
      });
      this.activeTab = i;

      // get page title if it hasn't been passed (could probably just always get page title this way)
      if (!page || page.length === 0) {
        page = this.tabTitle(i);
      }
      this.navTitle = i > 3 ? page : this.nav(i);
      this.pageTitle = page;

      privateRouter
        .push({
          name: "SATs",
          query: {
            activeTab: this.activeTab
          }
        })
        .catch(() => {});

      window.scrollTo(0, 0);
    },
    tabTitle(tabIndex) {
      switch (tabIndex) {
        case 0:
          return "Welcome, " + this.getFirstName;
        case 1:
          return "My saved assessments";
        case 2:
          return "Notifications";
        case 3:
          return "My account";
        default:
          return "Assessments overview"; //shouldn't get here
      }
    },
    nav(tabIndex) {
      switch (tabIndex) {
        case 0:
          return "Assessments overview";
        case 1:
          return "My saved assessments";
        case 2:
          return "Notifications";
        case 3:
          return "My account";
        default:
          return "Assessments overview"; //shouldn't get here
      }
    },
    inputChangedInAccount() {
      this.unsavedChanges = true;
      this.$emit("inputChangedInAccount");
    },
    changesSavedOrCancelledInAccount() {
      this.unsavedChanges = false;
      this.$emit("changesSavedOrCancelledInAccount");
    }
  },
  computed: {
    ...mapGetters("users", ["getFirstName"]),
    newNotifications() {
      let newNotifications = 0;
      this.notifications.forEach(notification => {
        if (notification.NewNotification) {
          newNotifications++;
        } //for new notifications message on button
      });
      return newNotifications;
    }
  }
};
</script>

<style lang="scss" scoped>
// @import "~@/assets/sass/index.scss";
</style>
